import { Link } from 'react-router-dom';
import { featuredVideos } from '@/mocks/videos';

const categoryNames: Record<string, string> = {
  entertainment: '娱乐综艺', education: '教育学习', technology: '科技数码',
  lifestyle: '生活美食', sports: '体育竞技', music: '音乐舞蹈',
  gaming: '游戏动漫', documentary: '纪录纪实', fashion: '时尚美妆', kids: '少儿乐园',
};

const formatViews = (n: number) => {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万次观看`;
  return `${n}次观看`;
};

export default function VideoGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">热门推荐</h2>
            <p className="text-sm text-foreground-500">精选优质视频，精彩不容错过</p>
          </div>
          <Link
            to="/category/entertainment"
            className="hidden sm:inline-flex items-center gap-1 px-4 py-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              {/* Thumbnail */}
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded-md font-medium">
                  {video.duration}
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-white/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-play-fill text-primary-500 text-lg ml-0.5"></i>
                  </div>
                </div>
              </div>

              {/* Info */}
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 mb-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {formatViews(video.views)}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {video.date}
                  </span>
                </div>
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  <span className="px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {categoryNames[video.category] || video.category}
                  </span>
                  {video.tags.slice(0, 1).map((tag) => (
                    <span key={tag} className="px-2 py-0.5 text-xs rounded-full bg-background-100 text-foreground-500 whitespace-nowrap">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/entertainment"
            className="inline-flex items-center gap-1 px-5 py-2.5 text-sm font-medium text-primary-500 border border-primary-200 rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部视频
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}